import * as React from "react";
import {FormattedMessage} from "react-intl";
import {PublishedWfsFeatureTypeModel} from "./WfsPublishInfo";
import {ColumnsDescription, ColumnWidth} from "../../common/ui/table/ControlRoomColumns";
import {
  CONTROLROOM_TABLE_MINIMUM_HEIGHT,
  CONTROLROOM_TABLE_ROW_HEIGHT,
  createBasicTableComponent
} from "../../common/ui/table/ControlRoomTable";
import {getFirstParentWithWidth} from "../../common/util/Util";

export const WFS_PUBLISH_INFO_TABLE_ROW_HEIGHT = CONTROLROOM_TABLE_ROW_HEIGHT;

const columns: ColumnsDescription<PublishedWfsFeatureTypeModel> = {
  productName: {
    header: <FormattedMessage id="studio.services.wfs.publish.info.UI.table.productName"
                              defaultMessage="Product"/>,
    cellContent: (publishedProductTableModel) => publishedProductTableModel.productName,
    cellTooltip: (publishedProductTableModel) => publishedProductTableModel.productName,
    columnWidth: ColumnWidth.flex(4),
  },
  fileName: {
    header: <FormattedMessage id="studio.services.wfs.publish.info.UI.table.fileName" defaultMessage="File"/>,
    cellContent: (publishedProductTableModel) => publishedProductTableModel.fileName,
    cellTooltip: (publishedProductTableModel) => publishedProductTableModel.fileName,
    columnWidth: ColumnWidth.flex(3),
  },
  modelName: {
    header: <FormattedMessage id="studio.services.wfs.publish.info.UI.table.modelName" defaultMessage="Model"/>,
    cellContent: (publishedProductTableModel) => publishedProductTableModel.modelName,
    cellTooltip: (publishedProductTableModel) => publishedProductTableModel.modelName,
    columnWidth: ColumnWidth.flex(4),
  },
  featureTypeName: {
    header: <FormattedMessage id="studio.services.wfs.publish.info.UI.table.featureTypeName"
                              defaultMessage="Feature Type"/>,
    cellContent: (publishedProductTableModel) => publishedProductTableModel.featureTypeName,
    cellTooltip: (publishedProductTableModel) => publishedProductTableModel.featureTypeName,
    columnWidth: ColumnWidth.flex(7),
  },
};

const getWfsPublishInfoTableDimensions = (parent: HTMLElement) => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  const baseResolution = 1920 * 1080; // Reference resolution
  const scalingFactor = (screenWidth * screenHeight) / baseResolution;
  const NO_ROWS_BEFORE_SCROLL = Math.max(4, Math.floor(scalingFactor * 5)); // Minimum 4 rows and then scale up to 5x

  const newParent: HTMLElement = getFirstParentWithWidth(parent);
  const paddingLeft = parseFloat(getComputedStyle(newParent).paddingLeft) || 0;
  const paddingRight = parseFloat(getComputedStyle(newParent).paddingRight) || 0;
  const windowInnerHeight = window.innerHeight;
  const parentTop = newParent.getBoundingClientRect().top;
  const availableHeight = windowInnerHeight - parentTop;

  const maxHeightThreshold = WFS_PUBLISH_INFO_TABLE_ROW_HEIGHT * NO_ROWS_BEFORE_SCROLL;
  const tableHeight = Math.max(
      CONTROLROOM_TABLE_MINIMUM_HEIGHT,
      Math.min(maxHeightThreshold, availableHeight)
  );

  const adjustedHeight = Math.floor(tableHeight / WFS_PUBLISH_INFO_TABLE_ROW_HEIGHT) *
                         WFS_PUBLISH_INFO_TABLE_ROW_HEIGHT;

  return {
    width: newParent.clientWidth - paddingLeft - paddingRight,
    height: adjustedHeight + 37 // 37 additional heights for header and borders
  };
};

export const WfsPublishInfoTable = createBasicTableComponent(columns, getWfsPublishInfoTableDimensions);